import { useContext } from 'react'
import { useQueryHook } from './queryHook'
import { apiGet } from '../api'
import { REGION_GET_LIST } from '../URLs'
import { LocaleContext } from '../../components/LocaleContext/LocaleContext'
import { TDictionaryItems } from '../../interfaces/IDictionary'
import { IRegionFindByName } from '../../interfaces/IRegionFindByName'

export const useRegionFindByName = (searchStringMinLength: number, params: IRegionFindByName) => {
  const { locale } = useContext(LocaleContext)
  const queryObject = useQueryHook({
    key: [REGION_GET_LIST, params.searchString],
    fetcherFunction: async () => {
      if (params.searchString.length < searchStringMinLength) {
        return Promise.resolve([])
      }

      const { data } = await apiGet<IRegionFindByName, TDictionaryItems>({
        path: REGION_GET_LIST,
        params,
        locale,
      })

      return data
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data || null,
  }
}
